import { useCallback } from 'react';
import { Cell } from 'src/components/organisms/DataTable/types';
import { FurnitureColumnType } from 'src/domain/models/FurnitureColumnType';
import { isPersistedFurnitureColumnType } from 'src/utils/furnitureUtils';
import { useStoreInventoryUnsavedChanges } from './save-changes/useStoreInventoryUnsavedChanges';
import { useStoreInventorySimulationRows } from './table/useStoreInventorySimulationRows';

export const useStoreInventoryHandleZoneCellChanges = () => {
    const { data: rows } = useStoreInventorySimulationRows();
    const [updatedRows, setUnsavedChanges] = useStoreInventoryUnsavedChanges();

    return useCallback(
        (cells: Cell<number>[]) => {
            for (const cell of cells) {
                if (!cell.column) continue;

                const rowId = Number(cell.rowId);
                const columnKey = cell.column.replace('furnitureColumns.', '');
                const existingRow = rows.find((row) => row.id === rowId);
                const currentValue = existingRow?.furnitureColumns?.[columnKey];

                if (!isPersistedFurnitureColumnType(currentValue)) continue;

                const existingUnsavedChanges = updatedRows.get(rowId);
                const updatedCell: FurnitureColumnType = {
                    ...currentValue,
                    chainFurnitureZoneId:
                        cell.value == null || cell.value.toString().trim() === '' || Number(cell.value) === 0
                            ? null
                            : Number(cell.value),
                };

                updatedRows.set(rowId, {
                    ...existingUnsavedChanges,
                    furnitureColumns: {
                        ...existingUnsavedChanges?.furnitureColumns,
                        [columnKey]: updatedCell,
                    },
                });
            }

            setUnsavedChanges(updatedRows);
        },
        [rows, setUnsavedChanges, updatedRows]
    );
};
